import { normalizeCouponCode } from "@/lib/pending-coupon"

/** Query flag the referral redirect adds to the storefront URL (`?indicacao=1`). */
export const REFERRAL_LANDING_PARAM = "indicacao"

/** Generic welcome benefit shown when the program carries no specific text. */
export const REFERRAL_FRIEND_FALLBACK = "um cupom de desconto"

/** Generic reward benefit shown when the program carries no specific text. */
export const REFERRAL_REFERRER_FALLBACK = "um cupom de recompensa"

const FIRST_ORDER = "primeiro pedido"

function benefitPhrase(text: string | undefined, fallback: string): string {
  const trimmed = text?.trim()
  if (!trimmed) return fallback
  const [first = "", second = ""] = trimmed
  const lowerable = first !== first.toLowerCase() && second !== "" && second === second.toLowerCase() && second !== second.toUpperCase()
  return lowerable ? first.toLowerCase() + trimmed.slice(1) : trimmed
}

function mentionsFirstOrder(phrase: string): boolean {
  return phrase.toLowerCase().includes(FIRST_ORDER)
}

/** What the referred friend wins, in plain words, from the program's real welcome benefit text. */
export function referralFriendBenefit(welcomeText?: string): string {
  const phrase = benefitPhrase(welcomeText, REFERRAL_FRIEND_FALLBACK)
  return `Seu amigo ganha ${phrase}${mentionsFirstOrder(phrase) ? "" : ` no ${FIRST_ORDER}`}.`
}

/** What the customer who shared the link wins, in plain words, from the program's real reward benefit text. */
export function referralReferrerBenefit(rewardText?: string): string {
  return `Você ganha ${benefitPhrase(rewardText, REFERRAL_REFERRER_FALLBACK)} quando o pedido do amigo for concluído.`
}

/** Landing context of a friend who arrived through a referral link. */
export type ReferralLanding = { couponCode: string }

/** Friendly WhatsApp message that invites a friend to order with the customer's referral link, naming the real welcome benefit when known. */
export function referralShareMessage(storeName: string | undefined, url: string, welcomeText?: string): string {
  const store = storeName?.trim() || "nossa loja"
  const phrase = benefitPhrase(welcomeText, REFERRAL_FRIEND_FALLBACK)
  return `Oi! Peça na ${store} pelo meu link e ganhe ${phrase}${mentionsFirstOrder(phrase) ? "" : " no seu primeiro pedido"}: ${url}`
}

/** `wa.me` share link (no recipient) that opens WhatsApp with the message prefilled. */
export function referralWhatsAppUrl(message: string): string {
  return `https://wa.me/?text=${encodeURIComponent(message)}`
}

/** The welcome coupon of a referral landing (`?indicacao=1&cupom=CODE`), or null for any other visit. */
export function readReferralLanding(search: string): ReferralLanding | null {
  try {
    const params = new URLSearchParams(search)
    if (params.get(REFERRAL_LANDING_PARAM) !== "1") return null
    const couponCode = normalizeCouponCode(params.get("cupom"))
    return couponCode ? { couponCode } : null
  } catch {
    return null
  }
}
